// src/routes/RequireAuth.tsx
import React, { PropsWithChildren } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext.tsx";

type RequireAuthProps = PropsWithChildren<{}>;

export default function RequireAuth({ children }: RequireAuthProps): JSX.Element | null {
  const { isAuthenticated, loading } = useAuth();
  const loc = useLocation();

  if (loading) return null; // можно заменить на спиннер

  if (!isAuthenticated) {
    const ret = encodeURIComponent(`${loc.pathname}${loc.search ?? ""}`);
    return <Navigate to={`/login?returnUrl=${ret}`} replace />;
  }

  return <>{children}</>;
}
